// extracted by mini-css-extract-plugin
export default {"banner":"E2","mobileImage":"F2","deskimg":"G2","desktopImage":"H2","wrapper":"I2","text":"J2","text_wrapper":"K2","breadContain":"L2","systemWrapper":"M2","system":"N2"};
    if(module.hot) {
      // 1713809679901
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  